<script>
  import notify from "../../../../../../Script/notify"
  import { sleep } from "../../../../../../Script/sleep"

  /**
   * @type {RegExp} - allowed regex for input value
   */
  export let regex = null
  /**
   * @type {RegExp} - regex for  replacing not allowed character from input value
   */
  export let replaceRegex = null

  /**
   * @type {String} - input value binded here
   */
  export let value = ""

  /**
   * @type {String} - error msg for not allowed character
   */
  export let errorMsg = ""

  /**
   * @type {String} - input name for get input value from form data
   */
  export let inputName = ""

  /**
   * @type {String} - input placeholder
   */
  export let placeholder = "placeholder"

  /**
   * @type {Boolean} - input disable state
   */
  export let disabled = false

  /**
   * @type {String} - input tootlip
   */
  export let tooltip = false

  /**
   * @type {String} - input icon
   */
  export let icon = "user"

  /**
   * @type {String} - input icon
   */
  export let maxLenght = 5

  /**
   * @type {String} - user name
   */
  export let userName = ""

  /**
   * @type {Boolean} - input required
   */
  export let required = false

  /**
   * @type {emptyNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @description function to check the input value matches the regex while on keypress event
   * @param e - to capture key event
   * @function checkRegexWhileOnKeyPress
   */
  const checkRegexWhileOnKeyPress = async (e) => {
    let { key } = e

    //not allowed charater enter to this block
    if (!regex.test(key)) {
      // close previous error notification
      closeNotification.close()
      e.preventDefault()

      //add last character to value
      value += key

      //throw error msg
      const info = `PAGE: Docket Creation\nEVENT: Validating ${tooltip} onKeypress`
      closeNotification = notify.danger(errorMsg, info)

      //remove invalid charactor from value
      await sleep(100)
      value = value.slice(0, -1)
    }

    if (value.length > maxLenght) {
      await sleep(100)
      closeNotification.close()
      value = value.slice(0, maxLenght)
      closeNotification = notify.info(`${userName} should not be more than ${maxLenght} characters`)
    }
  }

  /**
   * @description function to check the input value matches the regex while on blur event
   * @param e - to capture key event
   * @function checkRegexWhileOnBlur
   */
  const checkRegexWhileOnBlur = async () => {
    value = value.trim()

    //not allowed charater enter to this block
    if (!regex.test(value)) {
      // close previous error notification
      closeNotification.close()
      // Remove any characters that are not allowed
      let sanitizedText = value.replace(replaceRegex, "").trim()

      // Check if the sanitized text is the same as the original pasted text for error throwing
      if (sanitizedText !== value) {
        const info = `PAGE: Docket Creation\nEVENT: Validating ${tooltip} onBlur`
        closeNotification = notify.danger(errorMsg, info)
      }

      // Set the input value to the sanitized text
      value = sanitizedText
    }

    if (value.length > maxLenght) {
      await sleep(100)
      closeNotification.close()
      value = value.slice(0, maxLenght)
      closeNotification = notify.info(`${userName} should not be more than ${maxLenght} characters`)
    }
  }

  /**
   * @description function to check the input value matches the regex while on paste event
   * @param e - to capture key event
   * @function checkRegexWhileOnPaste
   */
  const checkRegexWhileOnPaste = async (e) => {
    // Get the pasted text from the clipboard
    let clipboardData = e.clipboardData || window.clipboardData
    let pastedText = clipboardData.getData("text/plain")

    await sleep(500)

    //not allowed charater enter to this block
    if (!regex.test(pastedText)) {
      closeNotification.close()
      // Remove any characters that are not allowed
      let sanitizedText = pastedText.replace(replaceRegex, "").trim()

      // Check if the sanitized text is the same as the original pasted text for error throwing
      if (sanitizedText !== pastedText) {
        const info = `PAGE: Docket Creation\nEVENT: Validating ${tooltip} onPaste`
        closeNotification = notify.danger(errorMsg, info)
      }

      // Set the input value to the sanitized text
      value = sanitizedText
    }

    if (value.length > maxLenght) {
      await sleep(100)
      closeNotification.close()
      value = value.slice(0, maxLenght)
      closeNotification = notify.info(`${userName} should not be more than ${maxLenght} characters`)
    }
  }
</script>

<!-- <input bind:value on:focus on:keypress={checkRegexWhileOnKeyPress} on:blur on:blur={checkRegexWhileOnBlur} on:paste={checkRegexWhileOnPaste} required name={inputName} id={inputName} type="text" {placeholder} autocomplete="off" class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white dark:placeholder:text-gray-200 sm:pr-9 sm:text-sm md:w-2/3" /> -->

<div class="group relative w-full rounded-md">
  <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-blue-500">
    <span data-tooltip={tooltip} tooltip-position="right">
      <i class="fa-solid fa-{icon}" />
    </span>
  </div>
  <input id={inputName} on:focus on:keypress={checkRegexWhileOnKeyPress} on:blur on:blur={checkRegexWhileOnBlur} on:paste={checkRegexWhileOnPaste} {disabled} {required} type="text" {placeholder} bind:value class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-9 pr-3 text-sm text-black outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed dark:text-white" />
</div>
